import React from 'react';
import { Collapse } from 'antd';
import type { CollapseProps } from 'antd';
import type { ReactNode } from 'react';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand_circle_down.svg';
import { ReactComponent as ExpandCloseIcon } from 'assets/icons/expand_circle_up.svg';
import styles from './accordion.module.scss';

const { Panel } = Collapse;

interface AccordionPanel {
  key: string;
  header: string | ReactNode;
  content: ReactNode;
}

export interface SharedAccordionProps extends CollapseProps {
  panels: AccordionPanel[];
  openIcon?: ReactNode;
  closeIcon?: ReactNode;
}

const SharedAccordion: React.FC<SharedAccordionProps> = ({
  panels,
  defaultActiveKey,
  accordion = false,
  onChange,
  bordered = true,
  openIcon = <ExpandIcon />,
  closeIcon = <ExpandCloseIcon />,
  expandIconPosition,
  activeKey
}) => {
  const renderExpandIcon: CollapseProps['expandIcon'] = panelProps =>
    panelProps.isActive ? closeIcon : openIcon;

  return (
    <div className={styles.accordionContainer}>
      <Collapse
        defaultActiveKey={defaultActiveKey}
        accordion={accordion}
        onChange={onChange}
        bordered={bordered}
        expandIconPosition={expandIconPosition}
        activeKey={activeKey}
        expandIcon={renderExpandIcon}>
        {panels.map(panel => (
          <Panel
            key={panel.key}
            header={
              <div className={styles.headerContainer}>{panel.header}</div>
            }>
            {panel.content}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default SharedAccordion;
